export const isEmailInvalid = (email: string): boolean => {
  const re = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  if (re.test(email) === true || email === "") {
    return false;
  }
  return true;
};
